"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _selectOptions = require("./select-options");
var _col = _interopRequireDefault(require("./col"));
var _row = _interopRequireDefault(require("./row"));
var _input = _interopRequireDefault(require("./input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SelectMultiCode extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getOptions", () => {
      if (!this.props.isLoaded) return [];
      return (0, _selectOptions.selectOptions)(this.props);
    });
  }
  render() {
    const colSize = this.props.colSize || 12;
    if (!(typeof colSize === 'number' && colSize >= 1 && colSize <= 12 && (colSize | 0) === colSize)) {
      return new Error('Expected a number between 1 and 12 for column size');
    }
    const numberOfColumns = Math.floor(12 / colSize);
    const options = this._getOptions();
    const optionsByColumns = [];
    for (let i = 0; i < numberOfColumns; i++) {
      optionsByColumns[i] = options.filter((opt, j) => {
        return j % numberOfColumns === i;
      });
    }
    return /*#__PURE__*/_react.default.createElement(_row.default, null, optionsByColumns.map((options, i) => /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: colSize,
      key: i
    }, options.map(option => /*#__PURE__*/_react.default.createElement(_input.default, {
      key: option.value,
      type: "Checkbox",
      name: this.props.name,
      checked: this.props.selectedCodes.indexOf(option.value) > -1,
      onChange: value => this.props.onChange(option.value, value),
      label: option.label,
      "data-test-id": this.props.name + '-checkbox-' + option.value
    })))));
  }
}

// *************************************************************
// Data
// *************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(SelectMultiCode, props => (0, _selectOptions.selectQuery)(props), undefined, {
  renderLoading: true
});